import React from "react";
import {
  Collapse,
  NavbarBrand,
  Navbar,
  NavItem,
  NavLink,
  Nav,
  Container,
} from "reactstrap";

function IndexNavbar() {
  const [navbarColor, setNavbarColor] = React.useState("navbar-transparent");
  const [collapseOpen, setCollapseOpen] = React.useState(false);
  React.useEffect(() => {
    const updateNavbarColor = () => {
      if (
        document.documentElement.scrollTop > 399 ||
        document.body.scrollTop > 399
      ) {
        setNavbarColor("");
      } else if (
        document.documentElement.scrollTop < 400 ||
        document.body.scrollTop < 400
      ) {
        setNavbarColor("navbar-transparent");
      }
    };
    window.addEventListener("scroll", updateNavbarColor);
    return function cleanup() {
      window.removeEventListener("scroll", updateNavbarColor);
    };
  });
  return (
    <>
      {collapseOpen ? (
        <div
          id="bodyClick"
          onClick={() => {
            document.documentElement.classList.toggle("nav-open");
            setCollapseOpen(false);
          }}
        />
      ) : null}
      <Navbar className={"fixed-top " + navbarColor} expand="lg" color="info">
        <Container>
          <div className="navbar-translate">
            <NavbarBrand href="https://bolthk.com" id="navbar-brand">
              BOLT (HK)
            </NavbarBrand>
            <button
              className="navbar-toggler navbar-toggler"
              onClick={() => {
                document.documentElement.classList.toggle("nav-open");
                setCollapseOpen(!collapseOpen);
              }}
              aria-expanded={collapseOpen}
              type="button"
            >
              <span className="navbar-toggler-bar top-bar"></span>
              <span className="navbar-toggler-bar middle-bar"></span>
              <span className="navbar-toggler-bar bottom-bar"></span>
            </button>
          </div>
          <Collapse
            className="justify-content-end"
            isOpen={collapseOpen}
            navbar
          >
            <Nav navbar>
              <NavItem>
                <NavLink
                  href="#about-us"
                  onClick={(e) => {
                    e.preventDefault();
                    document.getElementById("about-us").scrollIntoView();
                  }}
                >
                  <i className="now-ui-icons sport_user-run"></i>
                  <p>About Us</p>
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  href="#services"
                  onClick={(e) => {
                    e.preventDefault();
                    document.getElementById("services").scrollIntoView();
                  }}
                >
                  <i className="now-ui-icons ui-2_settings-90"></i>
                  <p>Services</p>
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  href="#products"
                  onClick={(e) => {
                    e.preventDefault();
                    document.getElementById("products").scrollIntoView();
                  }}
                >
                  <i className="now-ui-icons design_app"></i>
                  <p>Products</p>
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  href="#contact-us"
                  onClick={(e) => {
                    e.preventDefault();
                    document.getElementById("contact-us").scrollIntoView();
                  }}
                >
                  <i className="now-ui-icons ui-1_send"></i>
                  <p>Contact Us</p>
                </NavLink>
              </NavItem>
            </Nav>
          </Collapse>
        </Container>
      </Navbar>
    </>
  );
}

export default IndexNavbar;
